export class BrowserStore {
  constructor(key, schema) {
    this.key = key;
    this.schema = schema;
  }

  load() {
    try {
      const raw = localStorage.getItem(this.key);
      if (raw !== null) {
        const result = this.schema.safeParse(JSON.parse(raw));
        if (result.success) return result.data;
      }
    } catch {}
    return this.schema.parse({});
  }

  save(value) {
    try {
      localStorage.setItem(this.key, JSON.stringify(value));
    } catch {}
  }

  hasSavedData() {
    return localStorage.getItem(this.key) !== null;
  }

  clear() {
    try {
      localStorage.removeItem(this.key);
    } catch {}
  }
}
